"use client";

import { Button, buttonVariants } from "@/components/ui/button";
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyTitle } from "@/components/ui/empty";
import { SUPPORT_EMAIL } from "@/lib/support";

export default function PageError({ retry }: { retry: () => void }) {
  return <main className="flex min-h-svh items-center justify-center bg-muted/40 p-6">
    <Empty className="max-w-lg border bg-card shadow-sm">
      <EmptyHeader>
        <EmptyTitle><h1>We couldn’t load this page</h1></EmptyTitle>
        <EmptyDescription>Try loading it again. If the problem continues, contact Recoop support.</EmptyDescription>
      </EmptyHeader>
      <EmptyContent className="flex-row flex-wrap justify-center">
        <Button onClick={retry}>Retry loading</Button>
        <a href={`mailto:${SUPPORT_EMAIL}`} className={buttonVariants({ variant: "outline" })}>Email support</a>
      </EmptyContent>
    </Empty>
  </main>;
}
